import { GoogleDriveError } from '@getaccept/lib-shared/src/google-drive/types/enums/google-drive-error';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export class GoogleDriveHelper {
  static getErrorMessage(error: GoogleDriveError) {
    switch (error) {
      case GoogleDriveError.Authenticate:
        return t('failed-to-authenticate');
      case GoogleDriveError.Fetch:
        return t('failed-to-fetch-data-from-google-drive');
      case GoogleDriveError.Import:
        return t('failed-to-import-google-drive-document');
      default:
        return t('error-with-google-drive-integration');
    }
  }
}
